// Mirrors the backend CheqMe.Server.Contracts.General.CommunicationInformation record
// (Email_GDPR / Email_Administrative / Email_Invoicing, plus the optional Email_Operations). The monolith
// requires this object on the Company contract — omitting it triggers a 400 ("CommunicationInformation field
// is required"). email_Operations is optional (#153): when set it gets the customer notice of a fiscal ops alert;
// the internal alert always goes to the platform IT address (CHEQME_EMAIL_IT), never to the administrative
// address (#853).
export interface ICommunicationInformation {
  email_GDPR: string;
  email_Administrative: string;
  email_Invoicing: string;
  email_Operations: string;
}

export class CommunicationInformation implements ICommunicationInformation {
  email_GDPR: string = '';
  email_Administrative: string = '';
  email_Invoicing: string = '';
  email_Operations: string = '';

  static parse(obj: any): CommunicationInformation {
    const info = new CommunicationInformation();
    if (obj) {
      // Accept either PascalCase (server) or camelCase keys.
      info.email_GDPR = obj.email_GDPR ?? obj.Email_GDPR ?? '';
      info.email_Administrative = obj.email_Administrative ?? obj.Email_Administrative ?? '';
      info.email_Invoicing = obj.email_Invoicing ?? obj.Email_Invoicing ?? '';
      info.email_Operations = obj.email_Operations ?? obj.Email_Operations ?? '';
    }
    return info;
  }
}
